import { Action } from '@ngrx/store';

export enum TransactionActiveStatusActions {
    SelectTransactionStatus = '[Transaction Active Status] Select Transaction Active Status',
}

export class SelectTransactionActiveStatus implements Action {
    readonly type = TransactionActiveStatusActions.SelectTransactionStatus;
    constructor(public transactionId: string, public status: string, public index: number) {}
}

export type TransactionActiveStatusAction = SelectTransactionActiveStatus;
